const { AES, enc } = require('crypto-js')

/**
 * @param {string} data 
 * @param {string} encryptionKey 
 * @returns
 */
const _AESEncrypt = (data, encryptionKey) => {
    if (typeof data !== "string") return data
    return AES.encrypt(data, encryptionKey).toString()
}

/**
 * @param {string} data 
 * @param {string} encryptionKey 
 * @returns
 */
const _AESDecrypt = (data, encryptionKey) => {
    if (typeof data !== "string") return data
    return AES.decrypt(data, encryptionKey).toString(enc.Utf8)
}

/**
 * @param {object} data
 * @param {string[]} valueKeys type이 string인 값만 유효함
 * @param {string} encryptionKey 
 * @returns 
 */
exports.AESEncryptValues = (data, valueKeys, encryptionKey) => {
    valueKeys.forEach(key => {
        if (data.hasOwnProperty(key)) {
            data[key] = _AESEncrypt(data[key], encryptionKey)
        }
    })
    return data
}

/**
 * @param {object} data 
 * @param {string[]} valueKeys 
 * @param {string} encryptionKey 
 * @returns 
 */
exports.AESDecryptValues = (data, valueKeys, encryptionKey) => {
    if (!data) return data

    valueKeys.forEach(key => {
        
        if (data.hasOwnProperty(key)) { 
            data[key] = _AESDecrypt(data[key], encryptionKey)
        }
    })
    return data
}

exports.AESEncrypt = _AESEncrypt
exports.AESDecrypt = _AESDecrypt